import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../../env";

const SmsConfig = () => {
    const [configs, setConfigs] = useState([]);
    const [role, setRole] = useState("ADMIN");
    const [mobile, setMobile] = useState("");
    const [editId, setEditId] = useState(null);
    const [editMobile, setEditMobile] = useState("");
    const [personName, setPersonName] = useState("");
    const [editRole, setEditRole] = useState("");
    const [editPersonName, setEditPersonName] = useState("");

    const fetchConfig = async () => {
        try {
            const res = await axios.get(`${REACT_APP_API_URL}api/hrms/sms-config`);
            setConfigs(res.data.data || []);
        } catch (err) {
            alert("Failed to load SMS configuration");
        }
    };

    useEffect(() => {
        fetchConfig();
    }, []);

    const addMobile = async () => {
        if (!mobile || mobile.length !== 10) {
            alert("Enter a valid 10 digit mobile number");
            return;
        }

        try {
            const res = await axios.post(
                `${REACT_APP_API_URL}api/hrms/sms-config`,
                { role, personName, mobile }
            );

            alert(res.data.message);
            setMobile("");
            setPersonName("");
            fetchConfig();
        } catch (err) {
            alert(err.response?.data?.message || "Failed to add mobile");
        }
    };

    const toggleStatus = async (id, currentStatus) => {
        try {
            const res = await axios.put(
                `${REACT_APP_API_URL}api/hrms/sms-config/${id}/status`,
                { isActive: !currentStatus }
            );

            if (res.data.success) {
                alert(res.data.message);
                fetchConfig();
            } else {
                alert(res.data.message || "Operation failed");
            }
        } catch (err) {
            if (err.response?.data?.message) {
                alert(err.response.data.message);
            } else {
                alert("Something went wrong");
            }
        }
    };

    const updateConfig = async (id) => {
        if (!editMobile || editMobile.length !== 10) {
            alert("Enter valid 10 digit mobile number");
            return;
        }

        try {
            const res = await axios.put(
                `${REACT_APP_API_URL}api/hrms/sms-config/${id}`,
                {
                    role: editRole,
                    personName: editPersonName,
                    mobile: editMobile
                }
            );

            alert(res.data.message);
            setEditId(null);
            fetchConfig();
        } catch (err) {
            alert(err.response?.data?.message || "Update failed");
        }
    };

    return (
        <div className="container-fluid admin-module-page admin-profile-config-page py-4">
            <div className="admin-page-header d-flex align-items-start justify-content-between flex-wrap gap-3 mb-4">
                <div>
                    <span className="admin-page-kicker">Management Profile</span>
                    <h4 className="admin-page-title mb-1">Profile Configuration</h4>
                    <p className="admin-page-description mb-0">
                        Maintain the active management contact list.
                    </p>
                </div>
            </div>

            <div className="card admin-surface-card mb-4">
                <div className="card-header admin-surface-header">
                    <h6 className="card-title mb-0">Add New Profile Contact</h6>
                </div>
                <div className="card-body admin-surface-body">
                    <div className="row g-3 align-items-end">
                        <div className="col-md-3">
                            <label className="form-label fw-semibold">Role</label>
                            <select
                                className="form-select"
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                            >
                                <option value="ADMIN">Admin</option>
                                <option value="GM">General Manager</option>
                                <option value="MD">Managing Director</option>
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label className="form-label fw-semibold">Person Name</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Person Name"
                                value={personName}
                                onChange={(e) => setPersonName(e.target.value)}
                            />
                        </div>

                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Mobile Number</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="10 digit mobile number"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                                maxLength={10}
                            />
                        </div>

                        <div className="col-md-2 d-grid">
                            <button className="btn btn-primary admin-page-action" onClick={addMobile}>
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card admin-surface-card">
                <div className="card-header admin-surface-header fw-bold">Management Contacts</div>
                <div className="card-body admin-surface-body">
                    <div className="admin-table-shell">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Role</th>
                                    <th>Name</th>
                                    <th>Mobile</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {configs.length === 0 && (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-4">
                                            No Management profiles configured yet.
                                        </td>
                                    </tr>
                                )}

                                {configs.map(item => (
                                    <tr key={item.ConfigID}>
                                        <td>
                                            {editId === item.ConfigID ? (
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={editRole}
                                                    onChange={(e) => setEditRole(e.target.value)}
                                                >
                                                    <option value="ADMIN">Admin</option>
                                                    <option value="GM">General Manager</option>
                                                    <option value="MD">Managing Director</option>
                                                </select>
                                            ) : (
                                                <span className="badge bg-info text-dark">
                                                    {item.Role}
                                                </span>
                                            )}
                                        </td>

                                        <td>
                                            {editId === item.ConfigID ? (
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={editPersonName}
                                                    onChange={(e) => setEditPersonName(e.target.value)}
                                                />
                                            ) : (
                                                item.PersonName
                                            )}
                                        </td>

                                        <td>
                                            {editId === item.ConfigID ? (
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={editMobile}
                                                    maxLength={10}
                                                    onChange={(e) =>
                                                        setEditMobile(e.target.value.replace(/\D/g, ""))
                                                    }
                                                />
                                            ) : (
                                                item.Mobile
                                            )}
                                        </td>

                                        <td>
                                            {item.IsActive ? (
                                                <span className="badge bg-success">Active</span>
                                            ) : (
                                                <span className="badge bg-secondary">Inactive</span>
                                            )}
                                        </td>

                                        <td>
                                            {editId === item.ConfigID ? (
                                                <div className="d-flex flex-wrap gap-2">
                                                    <button
                                                        className="btn btn-sm btn-success"
                                                        onClick={() => updateConfig(item.ConfigID)}
                                                    >
                                                        Save
                                                    </button>

                                                    <button
                                                        className="btn btn-sm btn-secondary"
                                                        onClick={() => {
                                                            setEditId(null);
                                                            setEditMobile("");
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="d-flex flex-wrap gap-2">
                                                    <button
                                                        className="btn btn-sm btn-warning"
                                                        onClick={() => {
                                                            setEditId(item.ConfigID);
                                                            setEditRole(item.Role);
                                                            setEditPersonName(item.PersonName);
                                                            setEditMobile(item.Mobile);
                                                        }}
                                                    >
                                                        Edit
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${item.IsActive ? "btn-danger" : "btn-success"}`}
                                                        onClick={() => toggleStatus(item.ConfigID, item.IsActive)}
                                                    >
                                                        {item.IsActive ? "Deactivate" : "Activate"}
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SmsConfig;
